// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FChE7a {
  font-weight: 600;
}

.h00Rr6 {
  align-self: stretch;
  border-radius: 4px;
  background-color: #d64000;
  height: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.Q9j51L {
  align-self: stretch;
  border-radius: 4px;
  background-color: #387c2b;
  height: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.sexH2P {
  align-self: stretch;
  border-radius: 4px;
  background-color: #999;
  height: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.Ecd5ie {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.Y2HdPz {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
}

.sMIxXD {
  width: 24px;
  border-radius: 12px;
  background-color: #d64000;
  height: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.SJD3rN {
  width: 24px;
  border-radius: 12px;
  background-color: #387c2b;
  height: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.mWyuJJ {
  width: 24px;
  border-radius: 12px;
  border: 1px solid #999;
  box-sizing: border-box;
  height: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.I9c9GJ {
  flex: 1;
  position: relative;
  font-size: 16px;
  text-align: left;
}

.G6BnDm {
  flex: 1;
  position: relative;
  font-size: 16px;
  color: #1f1f1f;
  text-align: left;
}

.jHcHgc {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #fff;
}

.U6s5lc {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.qhHTiM {
  width: 100%;
  min-height: 124px;
  position: relative;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 24px 16px;
  gap: 12px;
  text-align: center;
  font-size: 14px;
  color: #999;
  font-family: var(--font-family-base);
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/StepperHorizontal/StepperHorizontal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":[".step {\n  font-weight: 600;\n}\n\n.dividerActive {\n  align-self: stretch;\n  border-radius: 4px;\n  background-color: #d64000;\n  height: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.dividerSuccess {\n  align-self: stretch;\n  border-radius: 4px;\n  background-color: #387c2b;\n  height: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.dividerDisabled {\n  align-self: stretch;\n  border-radius: 4px;\n  background-color: #999;\n  height: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.stepperTab {\n  align-self: stretch;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.stepperStep {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n}\n\n.groupActive {\n  width: 24px;\n  border-radius: 12px;\n  background-color: #d64000;\n  height: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.groupSuccess {\n  width: 24px;\n  border-radius: 12px;\n  background-color: #387c2b;\n  height: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.groupDisabled {\n  width: 24px;\n  border-radius: 12px;\n  border: 1px solid #999;\n  box-sizing: border-box;\n  height: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.stepTitleDisabled {\n  flex: 1;\n  position: relative;\n  font-size: 16px;\n  text-align: left;\n}\n\n.stepTitleActive {\n  flex: 1;\n  position: relative;\n  font-size: 16px;\n  color: #1f1f1f;\n  text-align: left;\n}\n\n.stepperHorizontalStepsActive {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  color: #fff;\n}\n\n.stepperHorizontalStepsDisabled {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.stepperHorizontal {\n  width: 100%;\n  min-height: 124px;\n  position: relative;\n  border-bottom: 1px solid #e6e6e6;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 24px 24px 16px;\n  gap: 12px;\n  text-align: center;\n  font-size: 14px;\n  color: #999;\n  font-family: var(--font-family-base);\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `FChE7a`,
	"dividerActive": `h00Rr6`,
	"dividerSuccess": `Q9j51L`,
	"dividerDisabled": `sexH2P`,
	"stepperTab": `Ecd5ie`,
	"stepperStep": `Y2HdPz`,
	"groupActive": `sMIxXD`,
	"groupSuccess": `SJD3rN`,
	"groupDisabled": `mWyuJJ`,
	"stepTitleDisabled": `I9c9GJ`,
	"stepTitleActive": `G6BnDm`,
	"stepperHorizontalStepsActive": `jHcHgc`,
	"stepperHorizontalStepsDisabled": `U6s5lc`,
	"stepperHorizontal": `qhHTiM`
};
module.exports = ___CSS_LOADER_EXPORT___;
